module.exports = __webpack_public_path__ + "assets/img/weixin-qr-code.1a723666.jpg";